// Value list for the quantity dropdowns: 0..n-1 when a zero option is wanted, 1..n when it is not.
export const createNumbersArray = (length: number, withNull: boolean) =>
  Array(length)
    .fill(0)
    .map((_, index) => {
      return { value: withNull ? `${index}` : `${index + 1}` }
    })
